import type * as ModelType from "@/components/features/faq/model/type";
import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import * as Composition from "./composition";

export const searchContentsConverter = (searchText: string, contents: Array<ModelType.Content>): SearchedContent => {
	// 検索ワードを単語に分割
	const splittedWords = Composition.Converter.splitWordsConverter(searchText);
	// 検索ワードにマッチするコンテンツを取得
	const matchedContents = Composition.Filter.matchedWordsWithContentsFilter(splittedWords, contents);

	// 検索コンテンツに変換
	const convertedSearchContents = Composition.Converter.contentsToSearchedContentsConverter(matchedContents);

	// ハイライトを適用
	const mappedSearchContents = Composition.Mapper.highlightMapper(splittedWords, convertedSearchContents);

	return mappedSearchContents;
};
